import { render, staticRenderFns } from "./subPageNice.vue?vue&type=template&id=0839d2b6&scoped=true"
import script from "./subPageNice.vue?vue&type=script&lang=js"
export * from "./subPageNice.vue?vue&type=script&lang=js"
import style0 from "./subPageNice.vue?vue&type=style&index=0&id=0839d2b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0839d2b6",
  null
  
)

export default component.exports